export function getEnv(variable: string): string | undefined {
  // @ts-ignore TS2339
  return window.env[variable];
}
